module.exports = __webpack_public_path__ + "media/21.327675c0.wav";